<template>
  <div class="actions-container" :class="categoryName">
    <div class="action-container">
      <action v-for="(action, index) of actions" :key="index" v-bind="action"/>
    </div>
  </div>
</template>

<script>

import Action from './Action.vue';

export default {
  name: 'Actions',
  components: {
    Action,
  },
  props: {
    actions: Array,
    categoryName: String,
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';

  .actions-container {
    &.variable {
      background-color: $riseup_yellow;
    }
    &.trackingCategory {
      background-color: $riseup_blue;;
    }
    &.excludedExpense {
      background-color: $riseup_black;
    }
    &.excludedIncome {
      background-color: $riseup_black;
    }
    &.fixedExpense {
      background-color: $riseup_red;
    }
    &.fixedIncome {
      background-color: $riseup_green;
    }
    &.variableIncome {
      background-color: $riseup_green;
    }
    &.fixedSaving {
      background-color: $riseup_savings;
    }
    &.oneTimeSaving {
      background-color: $riseup_savings;
    }

    padding: 0 20px;

    .action-container {
      border-bottom: 1px solid $riseup_white;
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
</style>
